// export const

import { Indonesian } from 'flatpickr/dist/l10n/id'

export function isWhatsAppHasScan(data) {
  return data.filter(item => item.is_scan === true)
}

export const fieldsBroadcastTable = [
  {
    key: 'tittle',
    label: 'Judul',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'broadcast_type',
    label: 'Tipe Pesan',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'contact_total',
    label: 'Jumlah Penerima',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'succes',
    label: 'Berhasil',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'failed',
    label: 'Gagal',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'status',
    label: 'Status Broadcast',
    thClass: 'font-bold text-center text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle  capitalize text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]
export const fieldsBroadcastForBrandsTable = [
  {
    key: 'title',
    label: 'Judul Tempalte',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'template_type',
    label: 'Tipe Pesan',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  // {
  //   key: 'total_contact',
  //   label: 'Jumlah Kontak',
  //   thClass: 'font-bold  text-black',
  //   class: 'align-middle text-center text-black',
  //   thStyle: {
  //     textTransform: 'capitalize',
  //     fontSize: '14px',
  //     color: 'black',
  //     fontWeight: 600,
  //   },
  // },
  {
    key: 'status',
    label: 'Status',
    thClass: 'font-bold text-center text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: 'font-bold capitalize text-black',
    class: 'align-middle text-center capitalize text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]

export const cardBroadcast = [
  {
    icon: 'https://storage.googleapis.com/komerce/assets/LP-Komchat/profile-circle.svg',
    text: 'Limit Kontak',
    cta: 'Tambah',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/assets/LP-Komchat/link-2.svg',
    text: 'Nomor Terhubung',
    cta: 'Tambah',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/assets/LP-Komchat/clock.svg',
    text: 'Expired',
    cta: 'Perpanjang',
  },
]

export const optionsDeliverySpeed = [
  {
    label: '5 Detik',
    value: 5,
  },
  {
    label: '10 Detik',
    value: 10,
  },
  {
    label: '1 Menit',
    value: 60,
  },
  {
    label: '3 Menit',
    value: 180,
  },
  {
    label: '5 Menit',
    value: 300,
  },
  {
    label: '10 Menit',
    value: 600,
  },
]

export const optionMode = [
  {
    label: 'Pengiriman Langsung',
    value: 'DIRECT',
  },
  {
    label: 'Pengiriman Terjadwal',
    value: 'SCHEDULED',
  },
]

export const optionsTemplate = [
  {
    label: 'Pesan Teks',
    value: 'TEXT',
    id: 0,
  }, {
    label: 'Pesan Media',
    value: 'MEDIA',
    id: 1,
  }, {
    label: 'Pesan Teks dan Pesan Media',
    value: 'TEXT_MEDIA',
    id: 2,
  },
]
export const optionsTypeContentForBrands = [
  {
    label: 'Pesan Teks',
    value: 'TEXT',
    id: 0,
  }, {
    label: 'Pesan Media',
    value: 'MEDIA',
    id: 1,
  },
]
export const optionsTemplateForBrands = [
  {
    label: 'Marketing',
    value: 'marketing',
    description: 'Promosi, Broadcast, Campaign, dll',
    id: 0,
  }, {
    label: 'Utility',
    value: 'utility',
    description: 'Notifikasi Pengiriman, Pengingat Pembayaran, dll',
    id: 1,
  }, {
    label: 'Authentication',
    value: 'authentication',
    description: 'OTP, Pemulihan Akun, Verifikasi Akun, dll',
    id: 2,
  },
]

export const configDate = {
  wrap: true,
  altFormat: 'j F Y',
  altInput: true,
  minDate: 'today',
  altInputClass: 'bg-white form-control',
  locale: Indonesian,
}

export const editorOption = {
  theme: 'bubble',
  placeholder: 'Masukan Teks Kamu Disini',
  modules: {
    toolbar: '#toolbar',
  },
  preserveWhitespace: true,
}
export const editorOptionContent = {
  theme: 'bubble',
  placeholder: 'Masukan Teks Kamu Disini',
  modules: {
    toolbar: '#content',
  },
  preserveWhitespace: true,
}
export const editorOptionCaption = {
  theme: 'bubble',
  placeholder: 'Masukan Teks Kamu Disini',
  modules: {
    toolbar: '#caption',
  },
  preserveWhitespace: true,
}

export const additionalVariable = [
  {
    var: '[NAMA LENGKAP]',
  },
  {
    var: '[ALAMAT]',
  },
  {
    var: '[LIST PRODUCT]',
  },
  {
    var: '[VARI1]',
  },
  {
    var: '[VARI2]',
  },
  {
    var: '[VARI3]',
  },
]
export const additionalVariableForBrands = [
  {
    var: '[NAMA LENGKAP]',
  },
]

export const toolbars = [
  {
    type: 'bold',
    icon: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/text-bold.svg',
  },
  {
    type: 'italic',
    icon: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/text-italic.svg',
  },
  {
    type: 'strike',
    icon: 'https://storage.googleapis.com/komerce/assets/icons/strikethrough.svg',
  },
  {
    type: 'emoji',
    icon: 'https://storage.googleapis.com/komerce/assets/elements/emote.svg',
  },
]

export const fieldsHistoryBroadcastForBrandsTable = [
  {
    key: 'title',
    label: 'Judul Broadcast',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'template_type',
    label: 'Tipe Pesan',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'status',
    label: 'Status',
    thClass: 'font-bold text-black',
    class: 'align-middle  text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'total_contact',
    label: 'Penerima',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'action',
    label: '',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]
export const fieldsDetailBroadcastForBrandsTable = [
  {
    key: 'sended_at',
    label: 'Tanggal',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'template_type',
    label: 'Category',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'status',
    label: 'Status',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'transaction_id',
    label: 'Transaction ID',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'cost',
    label: 'Amount',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]
export const fieldsDetailBroadcastLiteTable = [
  {
    key: 'sended_at',
    label: 'Waktu Pengiriman',
    thClass: 'font-bold text-black',
    class: 'align-middle  text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'contact',
    label: 'Kontak',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'template_type',
    label: 'Tipe Pesan',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'status',
    label: 'Status',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },

]

export function formatBalance(number) {
  if (number === null || number === undefined || Number.isNaN(number)) {
    return '0'
  }
  // Pastikan number adalah float
  const num = Number(number)
  // Pisahkan integer dan decimal
  const parts = num.toFixed(2).split('.')
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  // Jika decimal 0, tidak perlu tampilkan koma
  const decimalPart = parts[1] && parts[1] !== '00' ? `,${parts[1]}` : ''
  return integerPart + decimalPart
}

export function capitalizeWords(str) {
  if (!str) return str
  return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
}

export const fieldsKomchatCoinstable = [
  {
    key: 'date_payment',
    label: 'Tanggal',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      width: '20%',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'description',
    label: 'Deskripsi',
    thClass: 'font-bold text-black',
    class: 'align-middle text-start text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'amount',
    label: 'Amount',
    thClass: 'font-bold text-black',
    class: 'align-middle text-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      width: '15%',
      fontWeight: 600,
    },
  },
]
export const fieldsDetailBroadcastTable = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    sortable: true,
  },
  {
    key: 'name',
    label: 'Nama',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    sortable: true,
  },
  {
    key: 'phone',
    label: 'No. HP',
    thClass: 'font-bold',
    class: 'align-middle text-black',
  },
  {
    key: 'address',
    label: 'Lokasi',
    thClass: 'font-bold',
    class: 'align-middle text-black',
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: 'font-bold',
    class: 'align-middle text-black',
  },
]
export const status = [
  {
    label: 'Mengirim',
    value: 'PROCESSING',
  },
  {
    label: 'Terjeda',
    value: 'PAUSED',
  },
  {
    label: 'Selesai',
    value: 'SUCCESS',
  },
  {
    label: 'Dibatalkan',
    value: 'CANCELLED',
  },
  {
    label: 'Tidak Terkirim',
    value: 'FAILED',
  },
]

export const typeMessage = [
  {
    label: 'Text',
    value: 'TEXT',
  },
  {
    label: 'Media',
    value: 'MEDIA',
  },
  {
    label: 'Media & Text',
    value: 'TEXT_MEDIA',
  },
]
